const INITIAL_STATE = {
    data: null
};

const MunicipiosReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'municipios':
            return { ...state, data: action.payload.municipios };
        default:
            return state;
    }
};

export default MunicipiosReducer;
